import { Link } from "react-router-dom";

export const LegalLinks = ({ className = "", newTab = false }) => {
  const target = newTab ? { target: "_blank", rel: "noopener noreferrer" } : {};
  return (
    <p className={`flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-500 ${className}`} data-testid="legal-links">
      <span>Powered by Squadrum</span>
      <Link to="/terms" {...target} className="underline-offset-2 hover:text-slate-800 hover:underline" data-testid="legal-terms-link">Terms of Service</Link>
      <Link to="/privacy" {...target} className="underline-offset-2 hover:text-slate-800 hover:underline" data-testid="legal-privacy-link">Privacy Policy</Link>
    </p>
  );
};
